import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { api } from '../../api';
import { t } from '../../i18n';

@customElement('cadence-forgot-password-page')
export class CadenceForgotPasswordPage extends LitElement {
  @state() private email = '';
  @state() private loading = false;
  @state() private sent = false;

  static styles = css`
    :host { display: grid; place-items: center; min-height: 100vh; padding: var(--space-4); }
    .card {
      width: 100%; max-width: 400px; background: var(--color-bg-primary);
      border: 1px solid var(--color-border); border-radius: var(--radius-lg);
      box-shadow: var(--shadow-md); padding: var(--space-6);
    }
    h2 { margin: 0 0 4px; font-size: 1.2rem; }
    p.sub { margin: 0 0 var(--space-5); color: var(--color-text-secondary); font-size: 0.9rem; }
    form { display: flex; flex-direction: column; gap: var(--space-4); }
    .back { display: inline-block; margin-top: var(--space-4); color: var(--color-primary); text-decoration: none; font-size: 0.88rem; }
    .success { color: var(--color-success); font-size: 0.92rem; }
  `;

  private async submit() {
    if (!this.email) return;
    this.loading = true;
    try {
      await api.post('/auth/forgot-password', { email: this.email });
    } finally {
      this.loading = false;
      this.sent = true; // always show generic success (no account enumeration)
    }
  }

  render() {
    return html`
      <div class="card">
        <h2>${t('auth.forgot.title')}</h2>
        <p class="sub">${t('auth.forgot.subtitle')}</p>
        ${this.sent
          ? html`<p class="success" role="status">${t('auth.forgot.sent')}</p>`
          : html`
              <form @submit=${(e: Event) => { e.preventDefault(); this.submit(); }}>
                <cadence-input
                  label=${t('auth.forgot.email')}
                  type="email"
                  autocomplete="username"
                  .value=${this.email}
                  @input=${(e: CustomEvent) => (this.email = e.detail)}
                  @enter=${() => this.submit()}
                ></cadence-input>
                <cadence-button type="submit" full-width ?loading=${this.loading} @click=${() => this.submit()}>
                  ${t('auth.forgot.submit')}
                </cadence-button>
              </form>
            `}
        <a class="back" href="/login" data-link>${t('auth.forgot.back')}</a>
      </div>
    `;
  }
}
